export default __webpack_public_path__ + "static/media/appPic2.5c564601.png";